const MEDIA_KINDS = new Set(['image', 'video']);
const HEADER_MEDIA_KINDS = new Set(['image', 'video']);

function hasText(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

/**
 * Derives bubble layout hints for compact media rendering (WhatsApp-style).
 */
export function getMessageLayoutProfile(message) {
  const kind = message?.kind;
  const media = message?.media || {};
  const header = message?.header;
  const isStandaloneMedia = MEDIA_KINDS.has(kind) && Boolean(media.url);
  const isStandaloneDocument = kind === 'document' && Boolean(media.url);
  const isHeaderMedia = HEADER_MEDIA_KINDS.has(header?.kind) && Boolean(header?.url);

  const caption = hasText(media.caption)
    ? media.caption
    : (isStandaloneMedia || isStandaloneDocument) && hasText(message?.text)
      ? message.text
      : '';

  const templateBody = hasText(message?.template?.body) ? message.template.body : '';
  const hasTemplateText = hasText(templateBody) || hasText(message?.template?.footer);
  const hasCaption = hasText(caption);

  const isMediaPrimary =
    isStandaloneMedia && !hasCaption && !hasTemplateText && kind !== 'template';

  const isDocumentPrimary = isStandaloneDocument && !hasCaption && !hasTemplateText;

  const isAttachmentPrimary = isMediaPrimary || isDocumentPrimary;

  const isCompactMedia = isStandaloneMedia || isHeaderMedia;

  return {
    isMediaPrimary,
    isDocumentPrimary,
    isAttachmentPrimary,
    isCompactMedia,
    hasCaption,
    /** Timestamps always render below the bubble — never inline or on media overlay. */
    showInlineFooter: false,
    overlayMetaOnMedia: false,
    showMetaBelowBubble: true,
    showAttributionBelow: false,
  };
}
